<template>
  <div class="member-item-new hover-trigger" tabindex="1">
    <div class="name">
      <Avatar :name="member.employeeName" :url="previewFile(member.avatar)"></Avatar>
      <div class="flex-1">
        <div class="flex items-center">
          <div>{{ member.employeeName }}</div>
          <a-tag
            v-if="
              member.organizationAccountSeatType === OrgAccountSeatType.Preempt && member.onlineSeat
            "
            @click="forceExit"
            color="#DFF6E6"
            style="color: #2ebc52; margin-left: 8px; cursor: pointer;"
            >在线</a-tag
          >
          <!-- <EditOutlined class="edit-icon hover-item" @click="editName"></EditOutlined> -->
        </div>
      </div>
    </div>
    <!-- <div class="department">{{ member.departments }}</div> -->
    <Menu v-if="editable" :menus="menus" @click="handleMenuClick" meta="">
      <div class="role">
        {{ seatTypeName }}
        <CaretDownOutlined></CaretDownOutlined>
      </div>
    </Menu>
    <div v-else class="role">
      {{ seatTypeName }}
    </div>
    <!-- <div class="status">{{ member.stateName }}</div> -->
    <!-- <div class="date">{{ member.createdTime?.split(' ')[0] }}</div> -->
    <!-- <div class="operator">
      <Menu :menus="operators" @click="e => emit(e)">
        <EllipsisOutlined
          class="hover-item cursor-pointer"
          style="font-size: 16px"
          tabindex="-1"
        ></EllipsisOutlined>
      </Menu>
    </div> -->
  </div>
</template>

<script setup lang="ts">
import { Avatar, Modal, Menu } from '@elecmap/elecmap-ui'
import { computed, inject, reactive, type Ref } from 'vue'
import { CaretDownOutlined, EditOutlined, EllipsisOutlined } from '@ant-design/icons-vue'
import { updateEmployee } from '@elecmap/api/src/ram'
import { pick } from 'lodash-es'
import type { EmMenuItem } from '@elecmap/elecmap-ui/lib/menu/types'
import { previewFile } from '@elecmap/api/src/cad/file'
import userStore from '@/store/user'
import { storeToRefs } from 'pinia'
import { renderIcon } from '@elecmap/icon'
import type { EmployeeSeat } from '@elecmap/api/src/ram/seat.d'
import { OrgAccountSeatType, SeatType } from '@elecmap/api/src/ram/seat.d'
import { forceExitOnlineSeat } from '@elecmap/api/src/ram/seat'

const props = defineProps<{
  member: EmployeeSeat
}>()

const emit = defineEmits(['refresh', 'setSeat', 'removeUser', 'exitOrg'])

function seatTypeToDesc(seatType?: SeatType) {
  if (!seatType) return ''
  if (seatType === SeatType.SchematicDiagramDesign) {
    return '设计席位'
  }
  if (seatType === SeatType.View) {
    return '查看席位'
  }
}

const seatTypeName = computed(() => seatTypeToDesc(props.member.seatType))

const { canManage, userInfo } = storeToRefs(userStore())
const editable = computed(
  () => canManage.value && userInfo.value?.employeeId !== props.member.employeeId,
)

const menus: EmMenuItem[][] = [
  [
    {
      key: SeatType.SchematicDiagramDesign,
      name: '设计席位',
      icon: renderIcon(),
    },
    { key: SeatType.View, name: '查看席位', icon: renderIcon() },
    // { key: '252', name: '组件库管理员', icon: renderIcon() },
  ],
]

function handleMenuClick(key: string) {
  emit('setSeat', key)
}

function forceExit() {
  Modal.confirm({
    title: '提醒',
    content: `是否强制下线【${props.member.employeeName}】`,
    onOk() {
      forceExitOnlineSeat(props.member.employeeId).then(() => {
        emit('refresh')
      })
    },
  })
}

// function editName() {
//   Modal.form({
//     width: '400px',
//     title: `修改成员名称`,
//     formItems: [
//       {
//         label: '名称',
//         placeholder: '请输入名称',
//         type: 'Input',
//         key: 'employeeName',
//       },
//     ],
//     formState: reactive({ keywords: { ...props.member }, tags: {} }),
//     okText: '确认',
//     onSubmit: ({ keywords }: any) => {
//       updateEmployee({
//         ...(pick(props.member, [
//           'card',
//           'email',
//           'employeeId',
//           'employeeName',
//           'identification',
//           'kingdeeCode',
//           'userId',
//           'organizationId',
//         ]) as any),
//         employeeId: props.member.id,
//         employeeName: keywords.employeeName,
//       }).then((data: EmployeePageQuery) => {
//         data.roles = props.member.roles
//         emit('memberChange', { ...data })
//       })
//     },
//   })
// }
</script>

<style lang="less" scoped>
.member-item-new {
  display: flex;
  width: calc(100% + 16px);
  transform: translateX(-8px);
  padding: 8px;
  align-items: center;
  justify-content: space-between;
  transition: all 0.28s;
  border-radius: 5px;

  .name {
    display: flex;
    align-items: center;
    > div {
      margin-right: 8px;
    }
    :deep(.ant-avatar) {
      border-radius: 50%;
    }
    .account {
      transition: all 0.28s;
      margin: 0 4px;
      color: #bbb;
    }
    .edit-icon {
      transition: all 0.28s;
      cursor: pointer;
    }
  }

  .role {
    cursor: pointer;
  }

  &:hover,
  &:focus {
    background-color: #f5f5f5;
  }

  &:focus {
    .hover-item {
      opacity: 1;
    }
  }
}
</style>
